import {OSS_BUCKET, URL_CONFIG, VERSION_CONFIG} from '@/url_config';

const BASE_URL = URL_CONFIG.mi_url

export const commitFileLLMAnalyseTask = async({file_id, fileKey, rootKey, fileHash, imageKeys, projectId, noStructText, tasks, status_code, analyse_type}) => {
    console.log("file_id, fileKey, rootKey, fileHash, imageKeys, projectId, analyse_type", file_id, fileKey, rootKey, fileHash, imageKeys, projectId, status_code, analyse_type);
    const reqData = {
        project_id: projectId,
        project_file_id: file_id,
        project_file_key: fileKey,
        project_root_key: rootKey,
        project_file_hash: fileHash,
        image_keys: imageKeys,
        bucket: OSS_BUCKET,
        no_struct_text: noStructText,
        tasks: tasks,
        reprocess: status_code % 100 === 1,
        analyse_type: analyse_type,
        version: VERSION_CONFIG.url_version
    }
    console.log("commitFileLLMAnalyseTask req", reqData)
    let res = []

    const response = await fetch(`${BASE_URL}/mi_ai/file_analyse/task_commit`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(reqData),
    });

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    const data = await response.json();
    if (!data) {
        console.warn('commitFileLLMAnalyseTask res empty');
        return res
    }
    if (data['error']) {
        console.warn('Error commitFileLLMAnalyseTask:', data['error']);
        return res
    }
    res = data

    return res
};


// v2.0 后废弃
export const getFileLLMPreAnalyse = async(file_id, fileKey, rootKey, fileHash, imageKeys, project_id, tasks, reprocess) => {
    console.log("file_id, fileKey, rootKey, fileHash, imageKeys, project_id", file_id, fileKey, rootKey, fileHash, imageKeys, project_id);
    const reqData = {
        project_file_id: file_id,
        project_file_key: fileKey,
        project_root_key: rootKey,
        project_file_hash: fileHash,
        image_keys: imageKeys,
        no_struct_text: [],
        bucket: OSS_BUCKET,
        tasks: tasks,
        reprocess: reprocess
    }
    console.log("getFileLLMPreAnalyse req", reqData)
    let res
    try {
        const response = await fetch(`${BASE_URL}/mi_ai/file_pre_analyse/process_and_get_info`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqData),
        });

        if (!response.ok) {
            res = {
                "error": 'Network getFileLLMPreAnalyse response was not ok'
            }
            console.warn('Network getFileLLMPreAnalyse response was not ok');
            return res
        }

        const data = await response.json();
        if (!data) {
            console.warn('getFileLLMPreAnalyse res empty');
            return res
        }
        if (data['error']) {
            console.warn('Error commitFileLLMAnalyseTask:', data['error']);
            return res
        }
        res = data

    } catch (error) {
        console.error('Error uploading file:', error);
    }
    return res
};



/**
 * 获取分析结果。
 * 此函数会根据响应的 Content-Type 自动处理 JSON 或 SSE 流。
 *
 * @param {string} taskId - 要获取结果的任务 ID。
 * @param {function} onJsonReceived - (data: object) => void - 处理 JSON 数据的回调。
 * @param {function} onStreamChunkReceived - (chunk: string) => void - 处理 SSE 数据块的回调。
 * @param {function} onStreamEnd - () => void - SSE 流结束时的回调。
 * @param {function} onError - (error: Error) => void - 发生错误时的回调。
 * @returns {Promise<{ cancelStream: () => void } | null>}
 *          返回一个对象，包含一个 cancelStream 函数用于中止 SSE 流，
 *          或者在非流式请求或请求立即失败时返回 null。
 */
export async function fetchAnalysisResultApi(
    taskId,
    onJsonReceived,
    onStreamChunkReceived,
    onStreamEnd,
    onError
) {
    const apiUrl = `${BASE_URL}/mi_ai/file_analyse/res_get?project_file_id=${taskId}`;
    let response;
    let reader = null; // 用于 SSE 流的 reader

    // 用于外部取消流的函数
    const cancelStream = async () => {
        if (reader) {
            console.log(`[API] Cancelling stream for task ${taskId}`);
            try {
                await reader.cancel();
            } catch (e) {
                console.warn(`[API] Error cancelling SSE reader for task ${taskId}:`, e);
            } finally {
                reader = null; // 清理 reader
            }
        }
    };

    try {
        response = await fetch(apiUrl, {
            method: 'GET',
            // signal: abortController.signal, // 可以考虑使用 AbortController 进行更精细的取消控制
        });

        if (!response.ok) {
            let errorData = { message: `请求失败，状态码: ${response.status}` };
            try {
                const errJson = await response.json();
                errorData.message = errJson.detail || errJson.message || errorData.message;
            } catch (e) {
                try {
                    errorData.message = (await response.text()) || errorData.message;
                } catch (e2) { /* ignore secondary error */ }
            }
            throw new Error(typeof errorData.message === 'string' ? errorData.message : JSON.stringify(errorData.message));
        }

        const contentType = response.headers.get('Content-Type');

        if (contentType && contentType.includes('application/json')) {
            const jsonData = await response.json();
            console.log('[API] Received JSON data:', jsonData);
            if (typeof onJsonReceived === 'function') {
                onJsonReceived(jsonData);
            }
            return { cancelStream: () => {} }; // JSON 无需取消流

        } else if (contentType && contentType.includes('text/event-stream')) {
            console.log('[API] Received SSE stream. Processing...');
            if (!response.body) {
                throw new Error('SSE 流错误：响应体为空。');
            }

            reader = response.body.getReader(); // 将 reader 赋值给外部可访问的变量
            const decoder = new TextDecoder();

            const processStream = async () => {
                // eslint-disable-next-line no-constant-condition
                while (true) { // 持续读取，直到 done 或 reader 被取消
                    if (!reader) { // 如果 reader 被外部取消了
                        console.log(`[API] Stream reader for task ${taskId} was cancelled or cleared.`);
                        break;
                    }
                    try {
                        const { done, value } = await reader.read();

                        if (done) {
                            console.log(`[API] SSE Stream finished for task ${taskId}. ${value}`);
                            if (typeof onStreamEnd === 'function') {
                                onStreamEnd();
                            }
                            reader = null; // 流结束，清理 reader
                            break;
                        }

                        const chunk = decoder.decode(value, { stream: true });
                        // console.log('[API] SSE chunk:', chunk); // Debug
                        if (typeof onStreamChunkReceived === 'function') {
                            onStreamChunkReceived(chunk); // 直接传递原始 chunk
                        }
                    } catch (streamError) {
                        // 如果reader.read()因取消而失败，它会抛出DOMException "The user aborted a request."
                        // 我们需要判断是否是主动取消
                        if (reader) { // 如果 reader 仍然存在，说明不是主动取消
                            console.error(`[API] Error reading SSE stream for task ${taskId}:`, streamError);
                            if (typeof onError === 'function') {
                                onError(streamError instanceof Error ? streamError : new Error(String(streamError)));
                            }
                        } else {
                            console.log(`[API] Stream for task ${taskId} was cancelled during read.`);
                        }
                        reader = null; // 出错或取消时清理 reader
                        break; // 退出循环
                    }
                }
            };

            processStream().catch(err => { // 捕获 processStream 自身的未处理 Promise 拒绝
                if(reader) { // 如果 reader 还在，说明不是 cancelStream 导致的
                    console.error(`[API] Unhandled error in processStream for task ${taskId}:`, err);
                    if (typeof onError === 'function') {
                        onError(err);
                    }
                    reader = null;
                }
            });
            return { cancelStream }; // 返回取消函数

        } else {
            const textData = await response.text();
            console.warn('[API] Received unknown Content-Type:', contentType, 'Data:', textData);
            throw new Error(`不支持的响应类型: ${contentType}`);
        }

    } catch (error) {
        console.error(`[API] Fetch request failed for task ${taskId}:`, error);
        if (typeof onError === 'function') {
            onError(error instanceof Error ? error : new Error(String(error)));
        }
        // 确保如果 reader 已创建但发生错误，也尝试清理
        if (reader) {
            try { await reader.cancel(); } catch(e){}
            reader = null;
        }
        return null; // 或抛出错误，取决于你希望调用者如何处理
    }
}